<template>
  <div class="main">
    <c-panel title="Editoras e produtoras" titleIcon="fas fa-industry">
      <!-- Item 4: "cadastrar as editoras e produtoras dos materiais da biblioteca". -->
      <catalogo-crud tipo="editora" rotuloNovo="NOVA EDITORA" nomeSingular="registro"
                     placeholderBusca="Pesquisar por nome ou cidade"
                     :campos="campos" :colunas="colunas" :filtroExtra="filtroExtra"></catalogo-crud>
    </c-panel>
  </div>
</template>

<script>
import CatalogoCrud from '../catalogo/catalogo-crud.vue'

const TIPOS = [{ valor: 'editora', rotulo: 'Editora' }, { valor: 'produtora', rotulo: 'Produtora' }]

export default {
  components: { CatalogoCrud, cPanel: () => import('@/shared/c-panel/c-panel.vue') },
  data: () => ({
    campos: [
      { chave: 'nome', label: 'Nome', obrigatorio: true, span: 16, max: 191 },
      { chave: 'tipo', label: 'Tipo', tipo: 'select', obrigatorio: true, opcoes: TIPOS, padrao: 'editora', span: 8 },
      { chave: 'cnpj', label: 'CNPJ', span: 8, max: 18 },
      { chave: 'cidade', label: 'Cidade', span: 8, max: 120 },
      { chave: 'site', label: 'Site', span: 8, max: 191 }
    ],
    colunas: [
      { chave: 'nome', label: 'Nome' },
      { chave: 'tipo', label: 'Tipo', largura: '110px', mapa: { editora: 'Editora', produtora: 'Produtora' } },
      { chave: 'cidade', label: 'Cidade', largura: '160px', mobileOculto: true }
    ],
    filtroExtra: { chave: 'tipo_editora', label: 'Tipo', opcoes: TIPOS }
  })
}
</script>
